import { PltUser } from "@szgc/plt-core-v2";
import { NtkoLicenceModel, NtkoUseOptions, NtkoClientOpenOptions } from "../../types";

class NtkoAddon {
  licence: NtkoLicenceModel = {
    classid_x64: "A64E3073-2016-4baf-A89D-FFE1FAA10EE0",
    classid_x32: "A64E3073-2016-4baf-A89D-FFE1FAA10EC0",
    codebase_x64: "officecontrol/OfficeControlx64.cab#version=6.0.0.6",
    codebase_x32: "officecontrol/OfficeControl.cab#version=6.0.0.6",
    maker_caption: "",
    maker_key: "",
    prodcut_caption: "",
    product_key: ""
  };

  private _client_url: string = "";

  /**
   * 软航PDF阅读器地址
   */
  reader_iframe_url: string = "http://192.168.102.69:8099/ntko-doc-viewer";

  /**
   * 软航签章服务器地址
   */
  svr_url: string = "http://192.168.102.69:8080/ntkoSignServer/";

  /**
   * 登录模式,
   */
  signMode: string = "";
  authorizeCallback?: ((current: PltUser) => string | Promise<string>) | string = "";
  unauthorizeCallback?: ((current: PltUser) => string | Promise<string>) | string = "";

  get h5_svr_url() {
    const arr = Array.from(this.svr_url);
    if (arr[arr.length - 1] === "/") {
      arr.splice(arr.length - 1, 1);
      return arr.join("");
    } else {
      return this.svr_url;
    }
  }

  /**
   * 账号转换方案
   * @param current
   * @returns
   */
  account_convert: ((current: PltUser) => string | Promise<string>) | string = "";

  /**
   * 密码转换方案
   * @param current
   * @returns
   */
  password_convert: ((current: PltUser) => string | Promise<string>) | string = "";

  private load_assets(): Promise<{ success: boolean; message: string; error: any }> {
    return new Promise((resolve) => {
      const isproc = process.env.NODE_ENV === "production";
      const path = isproc ? "/process-public-resouce/ntko" : "/ntko";
      const ntkoAssetPath = location.origin + path;

      const ntkojs = document.createElement("script");

      ntkojs.src = ntkoAssetPath + "/officecontrol/ntkobackground.min.js";
      document.head.appendChild(ntkojs);

      ntkojs.onload = function () {
        resolve({
          success: true,
          message: "Load Ntko Control Success",
          error: null
        });
      };

      ntkojs.onerror = function (e) {
        resolve({
          success: false,
          message: "Load Ntko Control Fail",
          error: e
        });
      };
    });
  }

  /**
   * 启用Ntko控件
   * @description account_convert与password_convert必须同时存在，才会执行转换，否则默认软航账号密码始终是 空字符串
   * @param options { NtkoBootOptions }
   */
  public async use(options?: NtkoUseOptions) {
    window.NtkoAddonParams = {
      licence: {},
      callback: {}
    };

    if (options) {
      if (options.licence) {
        this.licence = {
          ...this.licence,
          ...options?.licence
        };
      }

      window.NtkoAddonParams.licence = this.licence;

      this.svr_url = options.svr_url || "";
      if (options.account_convert) {
        this.account_convert = options.account_convert;
      }

      if (options.password_convert) {
        this.password_convert = options.password_convert;
      }

      if (options.reader_iframe_url) {
        this.reader_iframe_url = options.reader_iframe_url;
      }

      if (options.signMode && options.authorizeCallback && options.unauthorizeCallback) {
        this.signMode = options.signMode;
        this.authorizeCallback = options.authorizeCallback;
        this.unauthorizeCallback = options.unauthorizeCallback;
      }
    }

    return await this.load_assets();
  }

  /**
   * 获取软航控件资源路径
   * @returns
   */
  getNtkoAssetPath() {
    const isproc = process.env.NODE_ENV === "production";
    const path = isproc ? "/process-public-resouce/ntko" : "/ntko";

    return location.origin + path;
  }

  close_client() {
    if (this._client_url) {
      ntkoBrowser.ntkoClose(this._client_url);
    }
  }

  /**
   * 打开软航控件客户端
   * @description 检测到软航控件未安装时，会自动打开安装页面
   * @param options
   */
  open(options: NtkoClientOpenOptions) {
    const ntko_installed = ntkoBrowser.ExtensionInstalled();
    if (ntko_installed) {
      this.open_client(options);
    } else {
      this.open_install();
    }
  }

  open_client(options: NtkoClientOpenOptions) {
    const ntkoAssetPath = this.getNtkoAssetPath();
    const url = new URL(ntkoAssetPath + "/client.html");
    url.searchParams.append("_t", Date.now().toString());
    const optionsStr = encodeURI(JSON.stringify(options));
    url.searchParams.append("options", optionsStr);
    this._client_url = url.toString();
    console.log("open client url: ", this._client_url);
    ntkoBrowser.openWindow(this._client_url, true);
  }

  /**
   * 打开软航控件安装页面
   */
  open_install() {
    const ntkoAssetPath = this.getNtkoAssetPath();

    const iTop = ntkoBrowser.NtkoiTop(); //获得窗口的垂直位置;
    const iLeft = ntkoBrowser.NtkoiLeft(); //获得窗口的水平位置;
    window.open(
      ntkoAssetPath + "/install.html",
      "",
      "height=200px,width=500px,top=" +
        iTop +
        "px,left=" +
        iLeft +
        "px,titlebar=no,toolbar=no,menubar=no,scrollbars=auto,resizeable=no,location=no,status=no"
    );
  }
}

export const ntko_addon = new NtkoAddon();

window.ntko_addon = ntko_addon;

